import { Inject, Injectable, Optional } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import moment, { Moment } from 'moment';
import 'moment-jdateformatparser';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';

@Injectable({
  providedIn: 'root',
})
export class AppDateAdapter extends MomentDateAdapter {
  formattedDate: any;

  constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string, private baseStoreService: BaseStoreService) {
    super(dateLocale);
  }

  format(date: Moment, displayFormat: any): string {
    date = this.clone(date);
    let formattedDate: any;
    if (displayFormat === 'input') {
      formattedDate = (moment() as any).toMomentFormatString(this.baseStoreService.baseStoreDateFormat$.value);
      return date.format(formattedDate);
    }
    if (!this.isValid(date)) {
      throw Error('MomentDateAdapter: Cannot format invalid date.');
    }
    return date.format(displayFormat);
  }
}

export const APP_DATE_FORMATS = {
  display: {
    dateInput: 'input',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
